export default "__VITE_ASSET__D9es9qNE__"